namespace Matrix.Data {
    export interface TestResultMutingRequest extends Serenity.ServiceRequest {
        BatchId?: number;
        TestCode?: string;
        MuteId?: number;
        UntilWhen?: string;
        Comment?: string;
    }
}
